import { Client } from "@stomp/stompjs";

const getToken = () => localStorage.getItem("accessToken");

const resolveWsUrl = () => {
  const base =
    process.env.REACT_APP_WS_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    window.location.origin;
  return `${base.replace(/^http/, "ws").replace(/\/$/, "")}/ws`;
};

export function connectChatSocket({ onMessage }) {
  const token = getToken();
  if (!token) return null;

  const client = new Client({
    brokerURL: resolveWsUrl(),
    connectHeaders: {
      Authorization: `Bearer ${token}`,
    },
    reconnectDelay: 4000,
    heartbeatIncoming: 10000,
    heartbeatOutgoing: 10000,
    onConnect: () => {
      client.subscribe("/user/queue/chat", (message) => {
        try {
          onMessage(JSON.parse(message.body));
        } catch {
          // REST reload remains the fallback.
        }
      });
    },
  });

  client.activate();
  return client;
}
